const ml = {
    'general_info': {
        'en': 'general information',
        'de': 'allgemeine informationen',
        'zh': '文章和页面'
    },
    'no_results': {
        'en': 'No matching results.',
        'de': 'Keine passenden Ergebnisse.',
        'zh': '没有匹配的结果.',
    },
    'view_all': {
        'en': 'View all ',
        'de': 'Alle ',
        'zh': '查看全部',
    },
    'programs': {
        'en': 'programs',
        'de': 'Programme',
        'zh': '课程',
    },
    'events': {
        'en': 'events',
        'de': 'Events',
        'zh': '活动',
    },
    'locations': {
        'en': 'locations',
        'de': 'Standorte',
        'zh': '地点',
    },
    'staff': {
        'en': 'staff',
        'de': 'Mitarbeiter',
        'zh': '成员',
    },
    'learn_more': {
        'en': 'Learn more',
        'de': 'Mehr',
        'zh': '了解更多',
    },
    'placeholder': {
        'en': 'Search...',
        'de': 'Suchen...',
        'zh': '搜索...',
    }
};

function get_current_lang() {
    let current_lang = document.documentElement.lang.split('-')[0].trim().toLowerCase()

    if (current_lang !== 'de' &&
        current_lang !== 'en' &&
        current_lang !== 'zh') {
        return 'de'
    }

    return current_lang
}

class Search {
    constructor() {
        this.currentLang = get_current_lang()
        this.addSearchHTML()

        this.resultsDiv = document.querySelector("#search-overlay__results")
        this.openButton = document.querySelectorAll(".js-search-trigger")
        this.closeButton = document.querySelector(".search-overlay__close")
        this.searchOverlay = document.querySelector(".search-overlay")
        this.searchField = document.querySelector("#search-term")
        this.isOverlayOpen = false
        this.isSpinnerVisible = false
        this.previousValue = ''
        this.typingTimer = null

        this.events()
    }

    events() {
        this.openButton.forEach((element) => {
            element.addEventListener("click", (event) => {
                event.preventDefault()
                this.openOverlay()
            })
        })

        this.closeButton.addEventListener("click", () => this.closeOverlay())
        document.addEventListener("keydown", (event) => this.keyPressDispatcher(event))
        this.searchField.addEventListener("keyup", () => this.typingLogic())
    }

    typingLogic() {
        if (this.searchField.value !== this.previousValue) {
            clearTimeout(this.typingTimer)

            if (this.searchField.value) {
                if (!this.isSpinnerVisible) {
                    this.resultsDiv.innerHTML = '<div class="spinner-loader"></div>'
                    this.isSpinnerVisible = true
                }

                this.typingTimer = setTimeout(this.getResults.bind(this), 750)
            } else {
                this.resultsDiv.innerHTML = ""
                this.isSpinnerVisible = false
            }
        }

        this.previousValue = this.searchField.value
    }

    getResults() {
        const results = search_by_keyword(this.searchField.value)
        this.resultsDiv.innerHTML = `
            <div class="row">
                <div class="one-third">
                    <h2 class="search-overlay__section-title">${ml['general_info'][this.currentLang]}</h2>
                    ${results.general_info.length ? '<ul class="link-list min-list">' : `<p>${ml['no_results'][this.currentLang]}</p>`}
                        ${results.general_info.map((item) => `
                            <li>
                                <a href="${item.permalink}">${item.title}</a>
                                ${item.description.length ? `<p>${item.description}</p>` : ''}
                            </li>
                        `).join('')}
                    ${results.general_info.length ? '</ul>' : ''}
                </div>
                <div class="one-third">
                    <h2 class="search-overlay__section-title">${ml['programs'][this.currentLang]}</h2>
                    ${results.program.length ? '<ul class="link-list min-list">' : `<p>${ml['no_results'][this.currentLang]} <a href="/program">${ml['view_all'][this.currentLang]}${ml['programs'][this.currentLang]}</a></p>`}
                        ${results.program.map((item) => `
                            <li>
                                <a href="${item.permalink}">${item.title}</a>
                                ${item.description.length ? `<p>${item.description}</p>` : ''}
                            </li>
                        `).join('')}
                    ${results.program.length ? '</ul>' : ''}

                    <h2 class="search-overlay__section-title">${ml['staff'][this.currentLang]}</h2>
                    ${results.staff.length ? '<ul class="link-list min-list">' : `<p>${ml['no_results'][this.currentLang]} <a href="/staff">${ml['view_all'][this.currentLang]}${ml['staff'][this.currentLang]}</a></p>`}
                        ${results.staff.map((item) => `
                            <li>
                                <a href="${item.permalink}">${item.title}</a>
                                ${item.description.length ? `<p>${item.description}</p>` : ''}
                            </li>
                        `).join('')}
                    ${results.staff.length ? '</ul>' : ''}
                </div>
                <div class="one-third">
                    <h2 class="search-overlay__section-title">${ml['locations'][this.currentLang]}</h2>
                    ${results.location.length ? '<ul class="link-list min-list">' : `<p>${ml['no_results'][this.currentLang]} <a href="/location">${ml['view_all'][this.currentLang]}${ml['locations'][this.currentLang]}</a></p>`}
                        ${results.location.map((item) => `
                            <li>
                                <a href="${item.permalink}">${item.title}</a>
                                ${item.description.length ? `<p>${item.description}</p>` : ''}
                            </li>
                        `).join('')}
                    ${results.location.length ? '</ul>' : ''}

                    <h2 class="search-overlay__section-title">${ml['events'][this.currentLang]}</h2>
                    ${results.event.length ? '<ul class="link-list min-list">' : `<p>${ml['no_results'][this.currentLang]} <a href="$/event">${ml['view_all'][this.currentLang]}${ml['events'][this.currentLang]}</a></p>`}
                        ${results.event.map((item) => `
                            <li>
                                <a href="${item.permalink}">${item.title}</a>
                                ${item.description.length ? `<p>${item.description}</p>` : ''}
                            </li>
                        `).join('')}
                    ${results.location.length ? '</ul>' : ''}
                </div>
            </div>
        `

        this.isSpinnerVisible = false
    }

    keyPressDispatcher(event) {
        if (event.keyCode === 83
            && !this.isOverlayOpen
            && document.activeElement.tagName !== "INPUT"
            && document.activeElement.tagName !== "TEXTAREA") {
            this.openOverlay()
        } else if (event.keyCode === 27 && this.isOverlayOpen) {
            this.closeOverlay()
        }
    }

    openOverlay() {
        this.searchOverlay.classList.add("search-overlay--active")
        document.body.classList.add("body-no-scroll")
        this.searchField.value = ""
        setTimeout(() => this.searchField.focus(), 300)
        this.isOverlayOpen = true
        return false
    }

    closeOverlay() {
        this.searchOverlay.classList.remove("search-overlay--active")
        document.body.classList.remove("body-no-scroll")
        this.isOverlayOpen = false
    }

    addSearchHTML() {
        document.body.insertAdjacentHTML(
            "beforeend",
            `
            <div class="search-overlay">
                <div class="search-over__top">
                    <div class="container">
                        <i class="fa fa-search search-overlay__icon" aria-hidden="true"></i>
                        <input class="search-term" id="search-term" type="text" placeholder="${ml['placeholder'][this.currentLang]}">
                        <i class="fa fa-window-close search-overlay__close" aria-hidden="true"></i>
                    </div>
                </div>

                <div class="container">
                    <div id="search-overlay__results"></div>
                </div>
            </div>
        `)
    }
}

function search_by_keyword(keyword) {
    const search_index = elasticlunr.Index.load(window.searchIndex);
    const res = search_index.search(
        keyword,
        {
            fields: {
                title: { boost: 2 },
                body: { boost: 1 }
            }
        });

    return group_by_post_type(res);
}

function get_post_type(search_result) {
    const post_id = new URL(search_result.doc.id);
    const lang_codes = ['de', 'en', 'zh'];
    const path_components = post_id.pathname.split('/').filter(element => element !== "" && !lang_codes.includes(element));
    const post_type = "page";

    if (path_components.length > 1) {
        return path_components[0];
    }

    return post_type;
}

function group_by_post_type(search_results) {
    let grouped = {
        "general_info": [],
        "event": [],
        "program": [],
        "location": [],
        "staff": [],
    };

    search_results.forEach(search_result => {
        let post_type = get_post_type(search_result);
        if (post_type === 'page' || post_type === 'news') {
            post_type = "general_info";
        }

        grouped[post_type].push({
            "title": search_result.doc.title,
            "permalink": search_result.ref,
            "post_type": post_type,
            "description": search_result.doc.description,
        });
    });

    return grouped;
}

export default Search